import * as React from "react";
import {
    IconButton as NuIconButton,
    Panel,
    IPanelStyles,
    PanelType,
    Nav,
    INavLinkGroup,
    INavStyles,
    nuOrderTheme,
} from "@nuorder/components";
import IconButton from "material-ui/IconButton";
import { $, merge, media } from "glamor";
import NuOrderIcon from "components/icons/nuorder";
import FlatButton from "material-ui/FlatButton";
import NotificationButton from "components/activity-feed/notification-button";
import classNames from "classnames";
import Caret from "components/icons/caret";
import Popover, { PopoverAnimationVertical } from "material-ui/Popover";
import MenuItem from "material-ui/MenuItem";
import MoreIcon from "material-ui/svg-icons/navigation/more-horiz";
import CloseIcon from "material-ui/svg-icons/navigation/close";
import Divider from "material-ui/Divider";
import { formatMessage } from "lib/globalize-util";
import { UserNotification } from "../product-collections/product-collections-user-notification";
import {
    INotification,
    IFeedEntry,
    INotificationFilters,
    INotificationStatusParams,
    IExportNotificationStatusParams,
    IFeedsFilters,
    IExportNotitications,
} from "reducers/notifications";
import { COLLECTION_FEED_SLUG } from "constants/product-collection";
import siteConfig from "site-config";
import { DATATEST } from "constants/integration";
import { DRIVE_LINK } from "containers/folders/utils/constants";
import { IExport } from "containers/folders/types/export";
import { withRouter } from "react-router";
import { useIsMerchantAdmin } from "hooks/useIsMerchantAdmin";
import { SearchSettings } from "constants/types";
import { themeOptions } from "styles/theme";

export const GLOBAL_TOP_BAR_HEIGHT = 60;

interface IHeaderProps {
    me: IMeProps;
    pageTitle: string;
    iconLink?: string;
    onFetchUserNotification?: (filters?: INotificationFilters, next?: boolean) => void;
    userNotification?: INotification[];
    userNotificationFetching?: boolean;
    userNotificationHasNextPage?: boolean;
    onLoadUserNotificationPolledEntries?: (userNotification: INotification[]) => void;
    onFetchFeeds?: (filters?: IFeedsFilters) => void;
    feeds?: IFeedEntry[];
    onUpdateUserNotifications?: (params: INotificationStatusParams) => void;
    merchantId?: string;
    displayUserNotifications?: boolean;
    exportNotifications?: IExportNotitications;
    onExportWhiteboards?: (exportItem: IExport) => void;
    onUpdateExportNotificationStatus?: (params: IExportNotificationStatusParams) => void;
    router?: any;
}

export interface IMeProps {
    cid: string;
    collection: string | object;
    parent: any;
    session: object;
    store: object;
    [props: string]: any;
}

export const CollectionHeader: React.FunctionComponent<IHeaderProps> = withRouter(
    ({
        me,
        pageTitle,
        iconLink = DRIVE_LINK,
        onFetchUserNotification,
        userNotification,
        userNotificationFetching,
        userNotificationHasNextPage,
        displayUserNotifications = true,
        onLoadUserNotificationPolledEntries,
        onFetchFeeds,
        feeds,
        onUpdateUserNotifications,
        merchantId,
        exportNotifications,
        onUpdateExportNotificationStatus,
        onExportWhiteboards,
        router,
    }) => {
        const styles = React.useMemo(
            () =>
                merge(
                    {
                        // borderBottom: `1px solid ${themeOptions.palette.lightGrey}`,
                        backgroundColor: themeOptions.palette.darkestGrey,
                        color: "rgba(255, 255, 255, .8)",
                        boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px",
                        display: "flex",
                        height: "60px",
                        maxHeight: "60px",
                        alignItems: "center",
                        paddingRight: "60px",
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        zIndex: 200,
                    },
                    $(" .appMenu", {
                        display: "flex",
                        height: "24px",
                        maxHeight: "24px",
                        alignItems: "center",
                        position: "relative",
                        padding: "0 8px",
                    }),
                    $(" .historyHeader", {
                        background: "white",
                        // color: themeOptions.palette.canvasColor,
                        padding: "8px 16px",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        zIndex: "1000",
                        display: "flex",
                        alignItems: "center",
                    }),
                    $(" .historyHeader .description", {
                        flexGrow: 1,
                        color: themeOptions.palette.darkGrey,
                    }),
                    $(" .historyHeader .title", {
                        fontSize: "16px",
                        lineHeight: "24px",
                        paddingTop: "0px",
                        color: themeOptions.palette.darkestGrey,
                    }),
                    $(" .rightPanel", {
                        alignItems: "center",
                        display: "flex",
                        height: "100%",
                        justifyContent: "flex-end",
                        paddingRight: "8px",
                    }),
                    $(" .toggleActionMenuButton", {
                        display: "none !important",
                    }),
                    media(
                        "(max-width: 780px)",
                        $(" .rightPanel", {
                            position: "absolute",
                            right: 0,
                            top: 0,
                            bottom: 0,
                            zIndex: 6,
                            backgroundColor: themeOptions.palette.darkestGrey,
                        }),
                        $(" .rightPanel.notOpen > *:not(.toggleActionMenuButton)", {
                            display: "none !important",
                        }),
                        $(" .rightPanel.isOpen", {
                            left: 0,
                        }),
                        $(" .toggleActionMenuButton", {
                            display: "inline-block !important",
                        }),
                        $(" .menuIconButton", {
                            display: "inline-block !important",
                        }),
                    ),
                    $(" .lastEdited", {
                        display: "inline-block",
                        paddingLeft: "50px",
                    }),
                    $(" .assortmentTitleContainer", {
                        maxWidth: "240px",
                        paddingRight: "8px",
                        textAlign: "left",
                        fontSize: "18px",
                        width: "100%",
                        lineHeight: "22px",
                        borderRadius: "4px",
                        textOverflow: "ellipsis",
                        background: "transparent",
                        color: "rgba(255, 255, 255, .94)",
                    }),
                    $(" .flexItemWide", {
                        flexGrow: 1,
                        flexShrink: 1,
                        height: "100%",
                        display: "flex",
                        minWidth: "0",
                        padding: "0 16px 0 0",
                        alignItems: "center",
                    }),
                    $(" .flexItemWide .iconButton svg", {
                        color: "rgba(255, 255, 255, .8) !important",
                    }),
                    $(" .flexItemWide .iconButton:hover svg", {
                        color: "rgba(255, 255, 255, 1) !important",
                    }),
                    $(" .appIcon", {
                        height: "100%",
                        width: "60px",
                        position: "relative",
                        display: "block",
                    }),
                    $(" .appIcon svg", {
                        height: "36px !important",
                        width: "36px !important",
                        color: "#82b4e4 !important",
                        top: "50%",
                        left: "16px",
                        position: "absolute",
                        transform: "translate3d(0, -50%, 0)",
                    }),
                    $(" .flexItemLeft", {
                        display: "flex",
                        height: "60px",
                    }),
                    $(" .notificationButton", {
                        width: 88,
                    }),
                    $(" .notificationIcon", {
                        color: "white",
                        height: 28,
                        width: 28,
                    }),
                    $(" .profile", {
                        borderLeft: "1px solid gray",
                    }),

                    $(" .profileButton", {
                        color: "rgba(255, 255, 255, .8) !important",
                    }),
                    $(" .profileButton span", {
                        maxWidth: "100px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                        whiteSpace: "nowrap",
                    }),
                    $(" .profileButton:hover", {
                        color: "rgba(255, 255, 255, 1) !important",
                    }),
                    $(" .profileButton svg", {
                        fill: "rgba(255, 255, 255, .8) !important",
                    }),
                    $(" .profileButton:hover svg", {
                        fill: "rgba(255, 255, 255, 1) !important",
                    }),
                    $(" .nuorderIconButton", {
                        height: "60px !important",
                        width: "68px !important",
                        paddingLeft: "18px !important",
                        marginRight: "4px !important",
                    }),
                    $(" .nuorderIconButton svg", {
                        height: "40px !important",
                        width: "40px !important",
                    }),
                    $(" .hamburgerIconButton", {
                        marginLeft: "23px",
                        maeringRight: "7px",
                    }),
                    $(" .hamburgerIconButton:hover", {
                        background: "none",
                    }),
                    $(" .hamburgerIconButton i", {
                        fill: "#FFF",
                        height: "24px",
                        width: "24px",
                    }),
                ),
            [],
        );

        const panelStyles = React.useMemo<Partial<IPanelStyles>>(
            () => ({
                main: {
                    marginTop: GLOBAL_TOP_BAR_HEIGHT,
                    left: 0,
                    right: "auto",
                },
                commands: {
                    display: "none",
                },
                content: {
                    padding: 24,
                },
            }),
            [],
        );

        const menuStyles = React.useMemo(
            () =>
                merge(
                    $(" .profileMenuItem", {
                        fontSize: "14px !important",
                    }),
                ),
            [],
        );

        const panelNavStyles = React.useMemo<Partial<INavStyles>>(
            () => ({
                root: {
                    selectors: {
                        ".is-selected button": {
                            fontWeight: "normal",
                        },
                    },
                },
                link: {
                    padding: "10px 8px 10px 0",
                    backgroundColor: "transparent !important",
                    color: nuOrderTheme.palette.greyDarker,
                    selectors: {
                        "&:hover": {
                            backgroundColor: "transparent !important",
                            color: `${nuOrderTheme.palette.themePrimary} !important`,
                        },
                        ".ms-Icon": {
                            fill: nuOrderTheme.palette.greyDarker,
                        },
                        "::after": {
                            border: "none",
                        },
                    },
                },
            }),
            [],
        );

        const { isMerchantAdmin } = useIsMerchantAdmin(merchantId, me?._id);

        const navLinkGroups: INavLinkGroup[] = [
            {
                links: [
                    {
                        name: formatMessage("Drive"),
                        key: "/drive",
                        isExpanded: router.location.pathname === "/drive",
                        url: null as string,
                        "data-test": DATATEST.MERCHANTS_APP.HAMBURGER_MENU_DRIVE_LINK,
                        iconProps: {
                            iconName: "myDrive24",
                            styles: {
                                root: {
                                    width: 24,
                                    height: 24,
                                },
                            },
                        },
                    },
                    ...(isMerchantAdmin
                        ? [
                              {
                                  name: formatMessage("Merchant Admin"),
                                  key: "/merchant/admin",
                                  isExpanded: router.location.pathname === "/merchant/admin",
                                  url: null as string,
                                  iconProps: {
                                      iconName: "settings24",
                                      styles: {
                                          root: {
                                              width: 24,
                                              height: 24,
                                          },
                                      },
                                  },
                                  "data-test": DATATEST.MERCHANTS_APP.HAMBURGER_MENU_MERCHANT_ADMIN_LINK,
                              },
                          ]
                        : []),
                    {
                        name: formatMessage("Help"),
                        url: "https://helpdesk.nuorder.com/hc/en-us",
                        target: "_blank",
                        iconProps: {
                            iconName: "helpCircle24",
                            styles: {
                                root: {
                                    width: 24,
                                    height: 24,
                                },
                            },
                        },
                        "data-test": DATATEST.MERCHANTS_APP.HAMBURGER_MENU_MERCHANT_HELP_LINK,
                    },
                ],
            },
        ];

        React.useEffect(() => {
            if (onFetchFeeds && displayUserNotifications && merchantId) {
                onFetchFeeds({ merchant_id: merchantId });
            }
        }, [displayUserNotifications, onFetchFeeds, merchantId]);

        React.useEffect(() => {
            if (onFetchFeeds && displayUserNotifications && merchantId) {
                onFetchFeeds({ merchant_id: merchantId });
            }
        }, [displayUserNotifications, onFetchFeeds, merchantId]);

        const handleLogout = React.useCallback(() => {
            localStorage.removeItem(SearchSettings.SearchType);
            me.logout();
        }, [me]);

        const profileRef = React.useRef<HTMLDivElement>();
        const notificationRef = React.useRef<HTMLDivElement>();
        const [isBurgerMenuOpen, setIsBurgerMenuOpen] = React.useState(false);
        const [profileMenuOpen, setProfileMenuOpen] = React.useState(false);
        const [notificationOpen, setNotificationOpen] = React.useState(false);
        const [isActionMenuOpen, setIsActionMenuOpen] = React.useState(false);
        const [collectionFeedStats, setCollectionFeedStats] = React.useState<IFeedEntry>();
        const handleBurgerMenu = React.useCallback(() => setIsBurgerMenuOpen(!isBurgerMenuOpen), [isBurgerMenuOpen]);
        const handleBurgerMenuDismiss = React.useCallback(() => setIsBurgerMenuOpen(false), []);
        const handleOpenProfileMenu = React.useCallback(() => setProfileMenuOpen(true), []);
        const handleCloseProfileMenu = React.useCallback(() => setProfileMenuOpen(false), []);
        const handleOpenNotification = React.useCallback(() => setNotificationOpen(true), []);
        const handleCloseNotification = React.useCallback(() => {
            setNotificationOpen(false);
            onUpdateExportNotificationStatus({
                seen: exportNotifications.exports.filter((item) => !item.is_seen).length,
            });
        }, [exportNotifications, onUpdateExportNotificationStatus]);
        const handleToggleActionMenu = React.useCallback(() => {
            setIsActionMenuOpen((state) => !state);
        }, []);

        const handleLinkClick = React.useCallback(
            (_, { key }) => {
                setIsBurgerMenuOpen(false);

                if (!key || key === router.location?.pathname) {
                    return;
                }

                router?.push({
                    pathname: key,
                    query: { ...(merchantId && { merchantId }) },
                });
            },
            [router, setIsBurgerMenuOpen, merchantId],
        );

        React.useEffect(() => {
            const _collectionFeedStats = (feeds || []).find((feed) => feed.feed_slug_id === COLLECTION_FEED_SLUG);
            setCollectionFeedStats(_collectionFeedStats);
        }, [feeds]);

        return (
            <div data-test={DATATEST.FOLDERS.DRIVE_PAGE_HEADER} className="assortmentHeader" {...styles}>
                <div className="flexItemWide">
                    <NuIconButton
                        data-test={DATATEST.NUORDER_HAMBURGER_MENU}
                        className="hamburgerIconButton"
                        iconProps={{ iconName: "hamburger24" }}
                        onClick={handleBurgerMenu}
                    />

                    <IconButton
                        data-test={DATATEST.NUORDER_LOGO_BTN}
                        className="iconButton nuorderIconButton"
                        href={iconLink}
                    >
                        <NuOrderIcon className="icon" />
                    </IconButton>

                    <div className="assortmentTitleContainer">{pageTitle}</div>
                </div>
                <div className={classNames("rightPanel", { notOpen: !isActionMenuOpen, isOpen: isActionMenuOpen })}>
                    {((siteConfig.ASSMT_USER_NOTIFICATION === "true" && onFetchFeeds && displayUserNotifications) ||
                        (!displayUserNotifications && exportNotifications.exports.length > 0)) && (
                        <div className="notification" ref={notificationRef}>
                            <NotificationButton
                                onClick={handleOpenNotification}
                                notice={
                                    (collectionFeedStats && collectionFeedStats.unseen !== "0") ||
                                    (exportNotifications && exportNotifications.unseen !== 0)
                                }
                                classes={{ root: "notificationButton", icon: "notificationIcon" }}
                                oldStyle={true}
                            />
                            <Popover
                                className={"userFeedPopover"}
                                style={{
                                    height: "500px",
                                }}
                                anchorEl={notificationRef.current}
                                anchorOrigin={{ horizontal: "middle", vertical: "bottom" }}
                                animation={PopoverAnimationVertical}
                                canAutoPosition={true}
                                onRequestClose={handleCloseNotification}
                                open={notificationOpen}
                                targetOrigin={{ horizontal: "middle", vertical: "top" }}
                            >
                                <UserNotification
                                    onRequestClose={handleCloseNotification}
                                    panelWidth={385}
                                    onFetchUserNotification={onFetchUserNotification}
                                    userNotification={userNotification}
                                    userNotificationFetching={userNotificationFetching}
                                    userNotificationHasNextPage={userNotificationHasNextPage}
                                    onLoadUserNotificationPolledEntries={onLoadUserNotificationPolledEntries}
                                    collectionFeedStats={collectionFeedStats}
                                    onUpdateUserNotifications={onUpdateUserNotifications}
                                    merchantId={merchantId}
                                    exportNotifications={exportNotifications}
                                    onExportWhiteboards={onExportWhiteboards}
                                    onUpdateExportNotificationStatus={onUpdateExportNotificationStatus}
                                />
                            </Popover>
                        </div>
                    )}
                    <div className="profile" ref={profileRef}>
                        <FlatButton
                            data-test={DATATEST.PROFILE.PROFILE_DROPDOWN}
                            className="profileButton"
                            label={me._firstName}
                            labelPosition="before"
                            onClick={handleOpenProfileMenu}
                            icon={<Caret />}
                        />
                        <Popover
                            anchorEl={profileRef.current}
                            anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
                            animation={PopoverAnimationVertical}
                            canAutoPosition={true}
                            onRequestClose={handleCloseProfileMenu}
                            open={profileMenuOpen}
                            targetOrigin={{ horizontal: "left", vertical: "top" }}
                        >
                            <div {...menuStyles}>
                                <MenuItem
                                    data-test={DATATEST.PROFILE.YOUR_PROFILE}
                                    href="/profile"
                                    primaryText={formatMessage("Your Profile")}
                                    className="profileMenuItem"
                                />
                                <MenuItem
                                    data-test={DATATEST.PROFILE.HELP}
                                    href="https://helpdesk.nuorder.com/hc/en-us"
                                    target="_blank"
                                    primaryText={formatMessage("Help")}
                                    className="profileMenuItem"
                                />
                                {iconLink === DRIVE_LINK && (
                                    <MenuItem
                                        data-test={DATATEST.PROFILE.ENTER_BRAND}
                                        href="/brands"
                                        primaryText={formatMessage("Switch to Brand Portal")}
                                        className="profileMenuItem"
                                    />
                                )}
                                {me.access_merchants && (
                                    <MenuItem
                                        data-test={DATATEST.PROFILE.SETTINGS}
                                        href={`/merchant/${me.merchant_connections[0]?.merchant_id}/settings`}
                                        primaryText={formatMessage("Settings")}
                                        className="profileMenuItem"
                                    />
                                )}
                                <Divider />
                                <MenuItem
                                    data-test={DATATEST.PROFILE.PROFILE_LOGOUT}
                                    primaryText={formatMessage("Sign Out")}
                                    onClick={handleLogout}
                                    className="profileMenuItem"
                                />
                            </div>
                        </Popover>
                    </div>
                    <IconButton className="iconButton toggleActionMenuButton" onClick={handleToggleActionMenu}>
                        {isActionMenuOpen ? (
                            <CloseIcon color="white" className="icon" />
                        ) : (
                            <MoreIcon color="white" className="icon" />
                        )}
                    </IconButton>
                    <Panel
                        isLightDismiss={true}
                        styles={panelStyles}
                        type={PanelType.custom}
                        customWidth={"285px"}
                        hasCloseButton={false}
                        isOpen={isBurgerMenuOpen}
                        onDismiss={handleBurgerMenuDismiss}
                        isBlocking={true}
                        layerProps={{
                            styles: {
                                root: {
                                    zIndex: 999,
                                },
                            },
                        }}
                    >
                        <Nav
                            styles={panelNavStyles}
                            onLinkClick={handleLinkClick}
                            ariaLabel={formatMessage("Nav")}
                            groups={navLinkGroups}
                        />
                    </Panel>
                </div>
            </div>
        );
    },
);
